import {
  SET_APPOINTMENT_DATA,
  SET_FILTERS_DATA,
  CLEAR_FILTERS_DATA,
  PREVIOUS_PATH,
  SET_PAGINATION_CONFIG,
  CLEAR_PAGINATION_CONFIG,
  FORM_FILTERS,
  FORM_FILTERS_CLEAR,
} from '../types';

const initialState = {
  appointmentData: {},
  filtersData: {},
  dataDeleted: null,
  previousPath: null,
  paginationConfig: {},
  formFilters: {},
};

export default function GeneralStates(state = initialState, action) {
  switch (action.type) {
    case SET_APPOINTMENT_DATA:
      return {
        ...state,
        appointmentData: { ...state.appointmentData, ...action.payload },
      };
    case SET_FILTERS_DATA:
      return {
        ...state,
        filtersData: { ...state.filtersData, ...action.payload },
      };
    case CLEAR_FILTERS_DATA:
      return {
        ...state,
        filtersData: {},
      };
    case PREVIOUS_PATH:
      return {
        ...state,
        previousPath: action.payload,
      };
    case SET_PAGINATION_CONFIG:
      return {
        ...state,
        paginationConfig: { ...state.paginationConfig, ...action.payload },
      };
    case CLEAR_PAGINATION_CONFIG:
      return {
        ...state,
        paginationConfig: {},
      };
    case FORM_FILTERS:
      return {
        ...state,
        formFilters: { ...state.formFilters, ...action.payload },
      };
    case FORM_FILTERS_CLEAR:
      return {
        ...state,
        formFilters: {},
      };
    default:
      return state;
  }
}
